import SectionHeader from "../components/SectionHeader";
import ServiceCard from "../components/ServiceCard";
import CTASection from "../components/CTASection";
import { SERVICES } from "../lib/business";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <section className="bg-secondary/60 border-b border-border">
        <div className="container-x py-14 sm:py-20">
          <SectionHeader
            eyebrow="Services"
            title="Professional handyman services across Montgomery County and beyond."
            subtitle="TV mounting, furniture assembly, fitness equipment assembly, appliance installation, and moving help — done carefully and cleanly."
          />
        </div>
      </section>
      <section className="section-y">
        <div className="container-x">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s) => (
              <ServiceCard key={s.slug} service={s} />
            ))}
          </div>
        </div>
      </section>
      <CTASection title="Don't see your project listed?" subtitle="Send us a quick message — chances are we can help." />
    </div>
  );
}
